import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "./Menu";
import { useNavigate } from "react-router-dom";
import SuccessMessage from "../components/successMessage";
import DialogBox from "../components/DialogBox";
import useApiUrls from "../useApiUrls";

const DeskTop = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isresponse, setIsresponse] = useState(null);
  const [popupState, setPopupState] = useState({ isOpen: false, type: null });
  const [disconnectedList, setDisconnectedList] = useState([]);
  const [connectedList, setConnectedList] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const { getUrlByOperation, error: urlError } = useApiUrls();

  const handleApiError = (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      navigate("/login");
    } else {
      setError(error);
    }
    setLoading(false);
  };

  // Modified to handle "connected" clicks differently
  const togglePopUp = (type) => {
    // If type is "connected", navigate to the Connected Devices page
    if (type === "connected") {
      navigate("/Connected-device");
      return;
    }
      if (type === "disconnected") {
      navigate("/Disconnected-device");
      return;
    }

    // For other types (like "disconnected"), show the popup as before
    // setPopupState((prevState) => ({
    //   isOpen: !prevState.isOpen,
    //   type: prevState.isOpen ? null : type,
    // }));

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      navigate("/login");
      return;
    }

    // Only fetch data for disconnected devices, since connected will navigate away
    const DeviceSataus = getUrlByOperation("disconnectedList");

    axios
      .get(DeviceSataus, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const { list, isresponse, errormsg } = response.data;
        setDisconnectedList(list || []);
        setLoading(false);
        setMessage(errormsg);
        setIsresponse(isresponse);
      })
      .catch(handleApiError);
  };

  const handleTotalDevice = () => {
    navigate("/merchantList");
  };

  const [showWelcomeMessage, setShowWelcomeMessage] = useState(false);

  useEffect(() => {
    const welcomeMessageShown = localStorage.getItem("welcomeMessageShown");

    if (welcomeMessageShown === "false") {
      setShowWelcomeMessage(true);
      localStorage.setItem("welcomeMessageShown", "true");
    }

    if (showWelcomeMessage === true) {
      const timer = setTimeout(() => {
        setShowWelcomeMessage(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showWelcomeMessage]);

  useEffect(() => {
    const token = getCookie("token");
    const userid = getCookie("userid");
    console.log(token, userid);

    console.log("desktop", token, userid)

    const fetchTotalDevices = () => {
      const totalDeviceUrl = getUrlByOperation("totalDevice");
      if (!totalDeviceUrl) return;

      axios
        .get(totalDeviceUrl, {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setData(response.data);
          setLoading(false);
        })
        .catch(handleApiError);
    };

    fetchTotalDevices();
    const interval = setInterval(fetchTotalDevices, 5000);

    return () => clearInterval(interval);
  }, [getUrlByOperation]);

  const getPopupContent = () => {
    // Since we're now only using this for disconnected, we can simplify
    const listToDisplay = disconnectedList;

    // Calculate pagination
    const totalPages = Math.ceil(listToDisplay.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = listToDisplay.slice(startIndex, startIndex + itemsPerPage);

    return (
      <>
        <table className="table table-hover text-nowrap">
          <thead>
            <tr>
              <th>userid</th>
              <th>posname</th>
              <th>merchantid</th>
              <th>key</th>
              <th>active</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.userid}</td>
                  <td>{item.posname}</td>
                  <td>{item.merchantid}</td>
                  <td>{item.key}</td>
                  <td>{item.active}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No disconnected devices found.</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination controls */}
        <div className="pagination">
          <button
            className="btn"
            id="previous"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            &lt;
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            className="btn"
            id="next"
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages || 1))}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            &gt;
          </button>
        </div>
      </>
    );
  };

  return (
    <>
      <Menu />
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Dashboard</h1>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-3 col-6"
                onClick={() => togglePopUp("connected")}
                style={{ cursor: 'pointer' }}
              >
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{data.connected}</h3>
                    <p>Connected Device</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-stats-bars" />
                  </div>
                  <a href="#" className="small-box-footer">
                    View Connected Devices <i className="fas fa-arrow-circle-right"></i>
                  </a>
                </div>
              </div>
              <div
                className="col-lg-3 col-6"
                onClick={() => togglePopUp("disconnected")}
                style={{ cursor: 'pointer' }}
              >
                <div className="small-box bg-danger">
                  <div className="inner">
                    <h3>{data.disconnected}</h3>
                    <p>Disconnected Device</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-pie-graph" />
                  </div>
                  <a href="#" className="small-box-footer">
                    View Disconnected Device <i className="fas fa-arrow-circle-right"></i>
                  </a>
                </div>
              </div>
              <div 
                className="col-lg-3 col-6" 
                onClick={handleTotalDevice}
                style={{ cursor: 'pointer' }}
              >
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{data.total}</h3>
                    <p>Total Device</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag" />
                  </div>
                  <a href="#" className="small-box-footer">
                    View All Devices <i className="fas fa-arrow-circle-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {popupState.isOpen && (
              <DialogBox
                currentText={getPopupContent()}
                setModalForText={() => togglePopUp(popupState.type)}
              />
            )}

            {showWelcomeMessage && (
              <SuccessMessage message="You are login successfully" />
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default DeskTop;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}